import React from "react";
import { NavLink } from "react-router-dom";
import ceilogo from "../../../img/cei-logo-new.jpg";
import memspa from "../../../img/logo-memspa.jpg";
import yale from "../../../img/yale.png";
import sel4ma from "../../../img/logo-sel4ma.jpg";
import naesp from "../../../img/logo-naesp.jpg";
import tl from "../../../img/tl_logo.png";
import usdoe from "../../../img/logo-usdoe.jpg";
import sponsor_one from "../../../img/sponsor-one.png";
import sponsor_two from "../../../img/sponsor-two.png";
import sponsor_three from "../../../img/sponsor-three.png";
import sponsor_four from "../../../img/sponsor-four.png";
import sponsor_five from "../../../img/sponsor-five.png";
import sponsor_six from "../../../img/sponsor-six.png";
import sponsor_seven from "../../../img/sponsor-seven.png";
import sponsor_eight from "../../../img/learning-forward-logo.png";

export default function NECLTC() {
  return (
    <div>
      <h3>Compassionate Schools Leadership Academy (CSLA)</h3>
      <div className="welcome welcome-left">
        <p>
          {/*To address equity, diversity, and mental health needs of students, the{" "}
          <b>Center for Educational Improvement</b> and <b>Yale University</b>{" "}
          are collaborating in a national project that involves:*/}
          To address mental health needs of students, the <b>Center for Educational Improvement</b> and <b>Yale University</b> collaborated in a national project from 2023-2025.
        </p>
        <ul className="welcome-list">
          <li>
            A Feasibility Study in Year 1. Schools participating in the
            Feasibility Study will have access to S-CCATE and its reports at no
            charge. Visit S-CCATE's{" "}
            <NavLink to="#pricing-welcome">products and pricing</NavLink> for more
            information.
          </li>
          <li>
            A National Survey. Schools participating in the National Survey will
            be able to access S-CCATE at no cost between March and September 2023.
          </li>
          <li>
            National Research Project. Schools participating in our National
            Research Project between September 2023 and July 2024 will be able
            to access S-CCATE at no charge.
          </li>
        </ul>
        <p>
          When S-CCATE is completed by 7 or more staff at a school, your school
          will receive results, including the S-CCATE Action Guide with options
          for implementation to address areas of needs.
        </p>
        <p>
          If you have questions about eligibility or want to learn more about the CSLA, please see this{" "}
          <a href="https://www.youtube.com/watch?v=lp0VCKnGg7Q">video</a>
          {" "}
          from our recent information session.
        </p>
        <div className="info-title welcome-left small-spacer">
          <h3>Our Partners</h3>
        </div>
        <div>
          {/* First outer div - 4 images flexed */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_one} alt="" />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_two} alt="" />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_three} alt="" />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_four} alt="" />
            </div>
          </div>

          {/* Second outer div - 3 images flexed */}
          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_five} alt="" />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_six} alt="" />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_seven} alt="" />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={sponsor_eight} alt="" />
            </div>
          </div>
          </div>
      </div>
    </div>
  );
}
